// extracted by css-extract-rspack-plugin
export default {"dialogHeaderContainer":"SignedCommitDialog-module__dialogHeaderContainer__rrNZr","signatureLinkContent":"SignedCommitDialog-module__signatureLinkContent__YyQz7"};